import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VALIDATED } from '../../../../../services/checkout/constants';
import { KYC_STATE_VALIDATED } from '../../../../../services/kyc/constants';

import { fetchCheckoutDetails } from '../../../../../services/checkout/actions';

import { getI18nByApp } from '../../../../../services/i18n/selector';

import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import { LoadingComponent } from '../../../../loading/LoadingComponent';

import { KycContainer } from './ConfirmationEbonPageKycBlocStyle';

const ConfirmationEbonPageKycBloc = ({
    orderId,
    fetchOrder,
    ebonOrderState,
    kyc,
    setKyc,
    kycValidated,
    setKycValidated,
    detailsInterval,
    setDetailsInterval,
    i18n,
    kycState,
    fetchCheckoutDetails
}) => {
    /* Start KYC verification */
    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            setKycValidated(true);
            setKyc(false);
            fetchCheckoutDetails(orderId);
        }
    }, [kycState]);

    useEffect(() => {
        if (kycValidated) {
            setDetailsInterval(
                setInterval(() => {
                    fetchCheckoutDetails(orderId);
                }, 5000)
            );
            return () => {
                clearInterval(detailsInterval);
            };
        }
    }, [kycValidated]);
    /* End KYC verification */

    return (
        !fetchOrder &&
        ebonOrderState !== VALIDATED &&
        !kyc &&
        kycValidated && (
            <KycContainer>
                <h3>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.EBON.CONFIRMATION.WAITING_TRANSACTION.TEXT_1')
                    )}
                </h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.EBON.CONFIRMATION.WAITING_TRANSACTION.TEXT_2')
                    )}
                </p>
                <div className="loader-wrapper">
                    <LoadingComponent />
                </div>
            </KycContainer>
        )
    );
};

ConfirmationEbonPageKycBloc.propTypes = {
    orderId: PropTypes.string,
    fetchOrder: PropTypes.bool,
    ebonOrderState: PropTypes.string,
    kyc: PropTypes.bool,
    setKyc: PropTypes.func,
    kycValidated: PropTypes.bool,
    setKycValidated: PropTypes.func,
    detailsInterval: PropTypes.number,
    setDetailsInterval: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n,
        kycState: state.kyc.state
    };
};

const mapDispatchToProps = {
    fetchCheckoutDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationEbonPageKycBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/kyc/ConfirmationEbonPageKycBloc.js